import Vue from 'vue';
import VueRouter from 'vue-router';

import LogIn from '../views/LogIn';
import NotFound from '../views/NotFound';

import store from '@/store';
import { AUTH_AUTOLOGIN } from '@/store/actions/auth';


function requireAuth (role) {
  return (to, from, next) => {
    if (!store.getters.isAuthenticated) {
      return next('login');
    }

    if (role && !store.getters.hasRole(role)) {
      return next('/');
    }

    next();
  };
}

function requireNoAuth () {
  return (to, from, next) => {
    if (store.getters.isAuthenticated) {
      next('/');
    } else {
      next();
    }
  };
}

function integerProps (arg) {
  let params = [];
  if (Array.isArray(arg)) {
    params = arg;
  } else {
    params.push(arg);
  }

  return (route) => {
    let props = {};

    for (let param of params) {
      const value = Number.parseInt(route.params[param]);
      if (!Number.isNaN(value)) {
        props[param] = value;
      }
    }

    return props;
  };
}


Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'login',
    component: LogIn,
    beforeEnter: requireNoAuth(),
    meta: {
      layout: 'no-nav',
      background: require('@/assets/BG_log_page.jpg')
    }
  },
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue'),
    beforeEnter: requireAuth(),
    meta: {
      background: require('@/assets/BG_header_vin.jpg')
    }
  },


  // CLIENTS
  {
    path: '/clients',
    name: 'clientList',
    component: () => import(/* webpackChunkName: "client_list" */ '../views/ClientList.vue'),
    beforeEnter: requireAuth('admin'),
    meta: {
      background: require('@/assets/BG_header_client.jpg')
    }
  },

  {
    path: '/client/:clientId/machines',
    name: 'clientMachineList',
    component: () => import(/* webpackChunkName: "machine_list" */ '../views/MachineList.vue'),
    beforeEnter: requireAuth('admin'),
    props: integerProps('clientId'),
    meta: {
      background: require('@/assets/BG_header_machines.jpg')
    }
  },

  {
    path: '/client/:clientId/wines',
    name: 'clientWineList',
    component: () => import(/* webpackChunkName: "client_list" */ '../views/ClientWineList.vue'),
    beforeEnter: requireAuth('admin'),
    props: integerProps('clientId'),
    meta: {
      background: require('@/assets/BG_header_vins.jpg')
    }
  },


  // PROVIDERS
  {
    path: '/providers',
    name: 'providerList',
    component: () => import(/* webpackChunkName: "provider_list" */ '../views/ProviderList.vue'),
    beforeEnter: requireAuth('admin'),
    meta: {
      background: require('@/assets/BG_header_producteur.jpg')
    }
  },


  // WINES
  {
    path: '/wines',
    name: 'wineList',
    component: () => import(/* webpackChunkName: "wine_list" */ '../views/WineList.vue'),
    beforeEnter: requireAuth(),
    meta: {
      background: require('@/assets/BG_header_vins.jpg')
    }
  },
  {
    path: '/wines/:wineId',
    component: () => import(/* webpackChunkName: "wine" */ '../views/Wine.vue'),
    beforeEnter: requireAuth(),
    props: integerProps('wineId'),

    children: [
      {
        path: '',
        name: 'wineDetail',
        component: () => import(/* webpackChunkName: "wine_detail" */ '../views/WineDetail.vue'),
        props: integerProps('wineId'),
        meta: {
          background: require('@/assets/BG_header_vin.jpg')
        }
      }
    ]
  },


  // MACHINES
  {
    path: '/machines',
    name: 'machineList',
    component: () => import(/* webpackChunkName: "machine_list" */ '../views/MachineList.vue'),
    beforeEnter: requireAuth(['admin', 'client']),
    meta: {
      background: require('@/assets/BG_header_machines.jpg')
    }
  },
  {
    path: '/machines/:machineId',
    component: () => import(/* webpackChunkName: "machine" */ '../views/Machine.vue'),
    beforeEnter: requireAuth(['admin', 'client']),
    props: integerProps('machineId'),

    children: [
      {
        path: '',
        name: 'machineDetail',
        component: () => import(/* webpackChunkName: "machine_detail" */ '../views/MachineDetail.vue'),
        props: integerProps('machineId'),
        meta: {
          background: require('@/assets/BG_header_machines_infos.jpg')
        }
      }
    ]
  },


  // Catch-all route for not-found paths
  {
    path: '*',
    component: NotFound
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (store.getters.isAuthenticated) {
    return next();
  }

  // Auto-login
  store.dispatch(AUTH_AUTOLOGIN, null)
    .then(() => {
      next();
    })
    .catch(() => {
      next();
    });
});

export default router;
